module.exports = __webpack_public_path__ + "static/media/transition.d2f132e2.png";